import { useEffect } from 'react';
import {
  useReturnStore,
  IReturnShipments,
  setReturnShipments,
} from '@src/stores/returnStore';
import { getMaxBoxesForShipment } from '@src/utils';

export const useInitializeBoxQuantities = (shouldInitialize: boolean) => {
  const orderDetailsV2 = useReturnStore((state) => state.orderDetailsV2);
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const returnShipments =
    useReturnStore((state) => state.returnShipments) || [];

  useEffect(() => {
    if (!shouldInitialize) return;
    // Initialize box quantity and calculate max boxes for each return shipment
    const updatedReturnShipments: IReturnShipments[] =
      returnShipments?.map((shipment) => {
        const initializedShipment: IReturnShipments = {
          ...shipment,
          boxQuantity: shipment.shipmentType === 'DROPOFF' ? 1 : undefined,
        };

        // Calculate max boxes for DROPOFF shipments
        if (shipment.shipmentType === 'DROPOFF') {
          const maxBoxes = getMaxBoxesForShipment(
            shipment,
            selectedItems,
            orderDetailsV2,
          );

          initializedShipment.maxBoxes = maxBoxes;
        }

        return initializedShipment;
      }) || [];

    setReturnShipments(updatedReturnShipments);
  }, [shouldInitialize]);
};
